<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont1">{{
        $t("P0402.announcementTemplateSetting")
      }}</span>
    </p>
    <!-- 新增按钮 -->
    <el-row style="bottom: 5px">
      <el-col
        :span="21"
        style="height: 44px; line-height: 44px; margin-left: 65px"
      >
        <el-button type="p0402add" style="float: left" @click="handleAdd()">{{
          $t("P0402.newTemplate")
        }}</el-button>
      </el-col>
    </el-row>
    <el-row style="top: 5px">
      <el-col :span="22" :offset="1">
        <el-table
          :data="announcementTemplateData"
          v-loading="pageLoading"
          style="width: 100%; margin-bottom: 75px"
        >
          <!-- 模板名称 -->
          <el-table-column
            prop="title"
            :label="$t('P0402.templateName')"
            align="left"
            min-width="60"
          >
          </el-table-column>
          <!-- 上次更新 -->
          <el-table-column
            prop="updateTime"
            :formatter="dateAndTimeFormat"
            :label="$t('P0402.lastUpdate')"
            align="center"
            min-width="95"
          >
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            :label="$t('common.operation')"
            align="center"
            min-width="60"
          >
            <template slot-scope="scope">
              <div class="blueDivider">
                <el-button type="text" @click="handleEdit(scope.row)">{{
                  $t("common.edit")
                }}</el-button>
                <el-divider direction="vertical">{{ "|" }}</el-divider>
                <el-button type="text" @click="deleteRow(scope.row)">{{
                  $t("common.delete")
                }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row><br /><br /></el-row>
    <!-- 对话框 -->
    <el-dialog
      :title="
        form && form.templateId
          ? $t('P0402.editGroupTemplate')
          : $t('P0402.newGroupTemplate')
      "
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="50%"
      class="el-dialog__body"
    >
      <div
        style="border-top: 0.5px solid #CCC;border-bottom: 0.5px solid #CCC;padding-bottom: 2px;width:98%; margin:auto;"
      >
        <el-form :model="form" ref="form">
          <el-form-item :label="$t('P0402.title')" prop="title">
            <el-input v-model="form.title" maxlength="255"></el-input>
          </el-form-item>
          <el-form-item :label="$t('P0402.content')" prop="content">
            <div style="text-align: right;">
              <span>{{ $t("P0402.variable") }}</span>
              <span
                >【<el-button size="text" @click="insertSlot('【课名】')">{{
                  $t("p0403.courseName")
                }}</el-button
                >】</span
              >
              <span
                >【<el-button
                  @click="insertSlot('【日期与时间】')"
                  size="text"
                  >{{ $t("p0403.dateAndTime") }}</el-button
                >】</span
              >
              <span
                >【<el-button @click="insertSlot('【公司】')" size="text">{{
                  $t("p0403.company")
                }}</el-button
                >】</span
              >
              <span
                >【<el-button @click="insertSlot('【地点】')" size="text">{{
                  $t("p0403.address")
                }}</el-button
                >】</span
              >
              <span
                >【<el-button
                  @click="insertSlot('【学习报告链接】')"
                  size="text"
                  >{{ $t("p0403.reportLink") }}</el-button
                >】</span
              >
              <span>
                <el-select
                  @change="insertSlot(codeValue)"
                  size="small"
                  v-model="codeValue"
                  placeholder="选择二维码"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option> </el-select
              ></span>
            </div>
            <el-input
              ref="inputRef"
              @blur="inputBlur"
              v-model="form.content"
              type="textarea"
              resize="none"
              :rows="8"
            ></el-input>
            <div style="text-align: left; color: red">
              <span>{{ $t("P0402.remark") }}</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-top: 16px">
        <!-- 新建按钮 -->
        <el-button
          type="p0402create"
          v-if="!form.templateId"
          size="big"
          @click.native="submit"
          >{{ $t("P0402.create") }}</el-button
        >
        <!-- 保存按钮 -->
        <el-button
          type="p0402create"
          v-if="form.templateId"
          size="big"
          @click.native="save"
          >{{ $t("common.save") }}</el-button
        >
        <!-- 另存为按钮 -->
        <el-button
          type="p0402save"
          v-if="form.templateId"
          size="big"
          @click.native="submit"
          >{{ $t("P0402.saveAsNewTemplate") }}</el-button
        >
        <!-- 返回按钮 -->
        <el-button
          type="p0402return"
          size="big"
          @click="dialogVisible = false"
          >{{ $t("common.back") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
import { cp } from "fs";
export default {
  data() {
    return {
      // 页面载入状态
      pageLoading: false,
      // 页面数据
      announcementTemplateData: [],
      // 对话框隐藏状态
      dialogVisible: false,
      // 表单数据
      form: {
        title: "",
        content: ""
      },
      // 表单提交状态
      //formLoading: false
      textCursor: 0,
      options: [
        {
          value: "【客服二维码】",
          label: "【客服二维码】"
        },
        {
          value: "【TQScloud公众号二维码】",
          label: "【TQScloud公众号二维码】"
        },
        {
          value: "【XTECH公众号二维码】",
          label: "【XTECH公众号二维码】"
        },
        {
          value: "【创建优惠码二维码】",
          label: "【创建优惠码二维码】"
        },
        {
          value: "【浏览选课二维码】",
          label: "【浏览选课二维码】"
        },
        {
          value: "【课程二维码】",
          label: "【课程二维码】"
        },
        {
          value: "【课程报名二维码】",
          label: "【课程报名二维码】"
        },
        {
          value: "【视频回放二维码】",
          label: "【视频回放二维码】"
        },
        {
          value: "【视频回放推广二维码】",
          label: "【视频回放推广二维码】"
        }
      ],
      codeValue: ""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      const loading = this.$loading({
        lock: true, //同v-loading的修饰符
        // text: "loading", //加载文案
        backgroundColor: "rgba(55,55,55,0.4)", //背景色
        // spinner: "el-icon-loading", //加载图标
        target: document.querySelector(".mainOne .is-scrolling-none") //loading需要覆盖的DOM节点，默认为body
      });
      let url = "/api/emailGroupView/getNoticeTemplate";
      this.$http
        .post(url)
        .then(response => {
          if (response.data.code === 200) {
            this.announcementTemplateData = response.data.data;
            this.pageLoading = false;
            loading.close();
          } else {
            this.pageLoading = false;
            this.$message.error(response.data.message);
            loading.close();
          }
        })
        .catch(err => {
          //console.log(err)
          loading.close();
          this.pageLoading = false;
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 时间标准化
    dateAndTimeFormat(row) {
      if (row.updateTime != null && row.updateTime != "") {
        return moment(row.updateTime).format("YYYY-MM-DD HH:mm");
      }
    },
    // 插入变量
    insertSlot(value) {
      if (this.dialogVisible) {
        setTimeout(() => {
          // const idx =  document.querySelector('#main-container > div.main-content > div > div > div.el-dialog__wrapper.el-dialog__body > div > div.el-dialog__body > div:nth-child(1) > form > div:nth-child(2) > div > div.el-textarea > textarea').selectionStart
          // console.log('exists: ',idx)
          var tmp1 = this.form.content.substring(0, this.textCursor);
          var tmp2 = this.form.content.substring(
            this.textCursor,
            this.form.content.length
          );
          this.form.content = tmp1 + value + tmp2;
          this.textCursor = this.textCursor + value.length;
          this.$refs["inputRef"].focus();
        }, 10);
      }
    },
    inputBlur() {
      this.textCursor = this.$refs.inputRef.$el.children[0].selectionStart;
      console.log(this.textCursor);
    },
    handleAdd() {
      this.form = {
        title: "",
        content: ""
      };
      this.codeValue = "";
      this.dialogVisible = true;
    },
    // 编辑
    handleEdit(row) {
      let url = "/api/emailGroupView/noticeTemplateDetail";
      this.$http
        .post(url, qs.stringify({ templateId: row.templateId }))
        .then(res => {
          if (res.data.code === 200) {
            this.form = {
              title: "",
              content: ""
            };
            this.codeValue = "";
            this.form.templateId = row.templateId;
            this.form.title = row.title;
            this.form.content = res.data.data.content;
            this.dialogVisible = true;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(() => {
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 新建、另存为新模板
    submit() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector(".main-content")
      });
      let url = "/api/emailGroupView/newNoticeTemplate";
      this.$http
        .post(
          url,
          qs.stringify({
            title: this.form.title,
            content: this.form.content,
            version: this.form.version
          })
        )
        .then(res => {
          if (res.data.code === 200) {
            loading.close();
            this.$message({
              message: res.data.data,
              type: "success"
            });
            this.dialogVisible = false;
            this.init();
          } else {
            loading.close();
            this.$message.error(res.data.message);
          }
        })
        .catch(e => {
          loading.close();
          this.init();
        });
    },
    //保存
    save() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector(".main-content")
      });
      let url = "/api/emailGroupView/updateNoticeTemplate";
      this.$http
        .post(
          url,
          qs.stringify({
            templateId: this.form.templateId,
            title: this.form.title,
            content: this.form.content,
            updateTime: this.form.updateTime
          })
        )
        .then(res => {
          if (res.data.code === 200) {
            loading.close();
            this.$message({
              message: res.data.data,
              type: "success"
            });
            this.dialogVisible = false;
            this.init();
          } else {
            loading.close();
            this.$message.error(res.data.message);
          }
        })
        .catch(e => {
          loading.close();
          this.$message.error(res.data.message);
          this.init();
        });
    },
    // 删除
    deleteRow(row) {
      // 是否删除该公司？
      this.$confirm(this.$t("P0402.ifDeleteTemplate"), {
        // 确定
        confirmButtonText: this.$t("common.confirm"),
        // 取消
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          background: "rgba(255,255,255,0.8)",
          target: document.querySelector("#main-container")
        });
        let url = "/api/emailGroupView/deleteNoticeTemplate/?templateId=";
        this.$http
          .get(url + row.templateId)
          .then(res => {
            this.pageLoading = false;
            if (res.data.code === 200) {
              this.$message({
                message: this.$t("common.deletedSuccessfully"),
                type: "success"
              });
              this.init();
            } else {
              this.$message.error(response.data.message);
            }
            loading.close();
          })
          .catch(err => {
            console.log(err);
            loading.close();
            this.$message.error(this.$t("common.anErrorOccurred"));
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

.blueDivider {
  display: inline-block;
}

.blueDivider >>> .el-divider--vertical {
  background-color: #00b0f0;
}

.foot-container {
  margin: 100px auto 0 auto;
  height: 26px;
  width: 50%;
  text-align: center;
}

/* p0402 */
/* email群模板 */
.el-button--p0402create:focus,
.el-button--p0402create {
  background-color: #00b0f0;
  border-color: rgb(0, 176, 240);
  height: 35px;
  width: 100px;
  white-space: pre-wrap;
  padding: 0 15px;
  font-family: "微软雅黑";
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  font-size: 13px;
  line-height: 24px;
}

.el-button--p0402save:focus,
.el-button--p0402save {
  background-color: #00b0f0;
  border-color: rgb(0, 176, 240);
  height: 35px;
  width: 130px;
  white-space: pre-wrap;
  padding: 0 15px;
  font-family: "微软雅黑";
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  font-size: 13px;
  line-height: 24px;
}

/* 返回 */
.el-button--p0402return {
  /* 999999 */
  background-color: #ffffff;
  /* 999999 */
  border-color: #d9d9d9;
  height: 35px;
  width: 100px;
  white-space: pre-wrap;
  padding: 0;
  font-family: "微软雅黑";
  font-weight: 400;
  font-style: normal;
  color: #000000;
  font-size: 13px;
  line-height: 18px;
}

.el-button--p0402add:focus,
.el-button--p0402add {
  background-color: #00b0f0;
  border-color: rgb(0, 176, 240);
  height: 35px;
  width: 100px;
  white-space: pre-wrap;
  padding: 0 15px;
  font-family: "微软雅黑";
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  font-size: 14px;
  line-height: 24px;
  border-radius: 6px;
}

>>> .el-dialog__body {
  padding-top: 10px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/EmailMarketing/P0402.vue